<ng-container *ngIf="(data$ | async) as data; else loading">

  <app-context-menu #contextMenu>

    <a role="anchor" class="gap-24" *ngIf="data.homes.length > 0 || data.friendHomes.length > 0 || data.favoriteHomes.length > 0">
      <app-icon class="text-24 home-selector-icon" name="home-selector"></app-icon>
      <div class="is-flex is-flex-grow-1 is-justify-space-between container-text-with-chevron">
        <app-text class="current-home ellipsis text-18 is-family-semiBold" [text]="data.currentHome.name"></app-text>
      
        <app-card-expand-icon [open]="contextMenu.showMenu$ | async"></app-card-expand-icon>
      </div>
    </a>

    <app-context-menu-item *ngFor="let home of data.homes"
      [class.selected]="home.id === data.currentHome.id"
      (click)="setCurrentHome(home.id)" [attr.data-home-id]="home.id"
      ga-event="SwitchOwnHome">
      <app-text>{{ home.name }}</app-text>

    </app-context-menu-item>

    <ng-container *ngIf="data.friendHomes.length > 0">

      <div class="menu-heading is-flex gap-12 is-family-semiBold">
        <app-icon class="text-24" name="users"></app-icon>
        <app-text class="text-14">{{ 'station-app.__SETTINGS_STATIONS_GUESTS' | AsyncLang | async }}</app-text>
      </div>

      <div class="heading-separator"></div>

      <app-context-menu-item *ngFor="let home of data.friendHomes"
        [class.selected]="home.id === data.currentHome.id"
        (click)="setCurrentHome(home.id)" [attr.data-home-id]="home.id"
        ga-event="SwitchGuestHome">

        <app-text
          class="marginless"
          [text]="home.name">
        </app-text>

      </app-context-menu-item>
    </ng-container>

    <ng-container *ngIf="data.favoriteHomes?.length > 0">

      <div class="menu-heading is-flex gap-12 is-family-semiBold">
        <app-icon class="text-24" name="l-love"></app-icon>
        <app-text class="text-14">{{ 'station-app.__SETTINGS_FAVORITES' | AsyncLang | async }}</app-text>
      </div>

      <div class="heading-separator"></div>

      <app-context-menu-item *ngFor="let home of data.favoriteHomes"
        [class.selected]="home.id === data.currentHome.id"
        (click)="setCurrentHome(home.id)" [attr.data-home-id]="home.id"
        ga-event="SwitchFavoriteHome">

        <app-text
          class="marginless"
          [text]="home.name">
        </app-text>

      </app-context-menu-item>

    </ng-container>

  </app-context-menu>

</ng-container>

<ng-template #loading>
  <app-context-menu>
    <a role="anchor" class="gap-24">
      <app-icon class="text-24" name="home-selector"></app-icon>
      <div class="dot-container">
        <div class="dot-flashing"></div>
      </div>
    </a>
  </app-context-menu>
</ng-template>

